import { render, staticRenderFns } from "./TrackerKing.vue?vue&type=template&id=0ffdfef9&scoped=true"
import script from "./TrackerKing.vue?vue&type=script&lang=js"
export * from "./TrackerKing.vue?vue&type=script&lang=js"
import style0 from "./TrackerKing.vue?vue&type=style&index=0&id=0ffdfef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffdfef9",
  null
  
)

export default component.exports